import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ThisReceiver } from '@angular/compiler';
import { Router } from '@angular/router';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';
import { AccountType } from '../../core/constants/accountTypes';
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
// import { noSpaceAtStartOrEnd } from '../../helpers/helper';

@Component({
  selector: 'app-new-chart-account',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule
],
  templateUrl: './new-chart-account.component.html',
  styleUrl: './new-chart-account.component.scss'
})
export class NewChartAccountComponent {
  accountType: any;
  search: any;
  accounts= Object.values(AccountType);
  isSubAccount: boolean = false;
  isControl: boolean = false;
  parentAccountId: any;
  chartAccounts: any;
  subAccount: any;
  createAccountForm: FormGroup
  chartAccountInput: any;
  private searchSubject = new Subject<string>();

  constructor(
    private chartAccountService : ChartOfAccountsService,
    private fb : FormBuilder,
    private toastr : ToastrService,
    private route : Router,
  ){}

  ngOnInit(){
    this.fetchChartAccounts();

    this.createAccountForm = this.fb.group({
      accountType: ['', Validators.required],
      accountName: ['', [Validators.required]],
      parentAccountId: [''],
      accountCode: ['', [Validators.required]],
      openingBalance: ['', [Validators.required,Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
      isControl : [false],
      status:1
    })
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search = searchTerm;
        this.fetchChartAccounts();
      });
  }

  toggleSubAccount(checked: boolean,type: string) {
    if(type == "subAccount"){
    this.isSubAccount = checked;
    this.createAccountForm.patchValue({
      isSubAccount: checked
    });
  }
  else if(type == "control"){
    this.isControl = checked;
    this.createAccountForm.patchValue({
      isControl: checked
    });
  }
  }

  fetchChartAccounts() {
    this.chartAccountService.fetchChartAccounts(this.search).subscribe({
      next: (data) => {
        this.chartAccounts = data;
      },
      error: (err) => {
        console.error('Error fetching chart accounts:', err);
      }
    });
  }

  onVendorSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value?.trim() || '';    
    this.searchSubject.next(searchTerm || '');
  }

  onSave(){
    if (this.createAccountForm.invalid) {
      this.createAccountForm.markAllAsTouched();
      return;
    } 
    const formValue = this.createAccountForm.value;

    this.chartAccountInput = {
      ...formValue,
      openingBalance: Number(formValue.openingBalance),
      parentAccountId: formValue.parentAccountId
        ? Number(formValue.parentAccountId)
        : null, 
      status: 1 
    };
    console.log(this.chartAccountInput);
    this.chartAccountService.createChartAccounts(this.chartAccountInput).subscribe({
      next: (data) => {
        if(data){
          this.createAccountForm.reset();
          this.toastr.success("Account created successfully", 'Success');
          this.route.navigate(['/chart-of-accounts'])
        }
      },
      error: (error) => {
        this.toastr.error(error?.message, 'Error')
      }
    })
  }

  onCancel(){
    this.createAccountForm.reset();
  }

}
